<mat-selection-list [multiple]="false">
    <mat-list-option *ngFor="let department of departments" [value]="department" (click)="select(department)">
      <div fxLayout="row">
        <div fxFlex="grow">{{department.name}}</div>
        <!-- <div fxFlex="40px;">
          <fa-icon [icon]="['fas','pencil']" (click)="editDepartment(department)"></fa-icon>
        </div> -->
        <div fxFlex="40px;">
          <fa-icon [icon]="['fas','trash']" (click)="removeDepartment(department)"></fa-icon>
        </div>
      </div>
    </mat-list-option>
</mat-selection-list>